import React, { useContext, useEffect, useState } from 'react'
import './ConfirmationDialog.css'
import ReactDOM from 'react-dom'
import API from '../../../../lib/api'
import moment from 'moment'
import { SplitContext } from 'containers/SplitContext'
import SPLIT_FEATURES from 'containers/SplitContext/features'
import { CAMPAIGN_LABELS_API } from 'config/app'

export const getLayoutUrl = (stage, page) => {
  const URL = {
    NEW_PAGE: `${CAMPAIGN_LABELS_API}/v1/page-management/${page}`,
    OLD_PAGE: `/website-service/layout/${page}`,
    NEW_DATE: `${CAMPAIGN_LABELS_API}/v1/page-management/${page}/date`,
    OLD_DATE: `/website-service/layout/${page}/date`,
    OLD_URL: `/website-service/layout`,
  }
  return URL[stage]
}

const ConfirmationDialog = ({ onConfirm, onCancel, title, message, page }) => {
  const [o2OTimelines, setO2OTimelines] = useState([])
  const [timeLine, setTimeLine] = useState('default')
  const splitConfig = useContext(SplitContext)

  useEffect(() => {
    const isNewLayoutAPIEnabled =
      splitConfig?.splits?.[SPLIT_FEATURES.BACK_DIS_WEBSITE_HOME_LAYOUT]
        ?.treatment === 'on' && page === 'home'
    const url = isNewLayoutAPIEnabled
      ? getLayoutUrl('NEW_DATE', 'home')
      : getLayoutUrl('OLD_DATE', 'home')
    const params = {
      platform: isNewLayoutAPIEnabled ? 'offline' : 'o2o',
    }
    const api = new API({ url })

    api
      .get(params)
      .then((resp) => {
        let timeLines = resp.data.date
        timeLines = timeLines
          .filter((time) => time.validTill && time.validFrom)
          .map((time) => {
            const startDatetime = moment(time.validFrom)
            const endDatetime = moment(time.validTill)
            return {
              value: `${time.validFrom}/${time.validTill}`,
              text: `${startDatetime.format('Do MMM')} ${startDatetime.format(
                'hh:mm A'
              )} ${' - '} ${endDatetime.format('Do MMM')} ${endDatetime.format(
                'hh:mm A'
              )}`,
            }
          })

        timeLines = [{ text: 'Default', value: 'default' }, ...timeLines]

        setO2OTimelines(timeLines)
      })
      .catch((error) => {
        console.error(`Unable to fetch timeline dates: ${error.message}`)
      })
  }, [])

  const [status, setStatus] = useState('DISABLED')

  const handleOptionChange = (changeEvent) => {
    setStatus(changeEvent.target.value)
  }

  const handleConfirm = () => {
    onConfirm({ status, timeLine })
  }

  return (
    <div className="confimation-dialog backMask" onClick={onCancel}>
      <div className="dialog" onClick={(e) => e.stopPropagation()}>
        <div className="header">{title}</div>
        <div className="content">{message}</div>
        {title === 'Duplicate' && (
          // Need a better way to inject extra components
          <form className="radio-buttons-container">
            <div className="radio">
              <label>
                <input
                  type="radio"
                  value="DISABLED"
                  checked={status === 'DISABLED'}
                  onChange={handleOptionChange}
                />
                Set as disabled
              </label>
            </div>
            <div className="radio">
              <label>
                <input
                  type="radio"
                  value="ENABLED"
                  checked={status === 'ENABLED'}
                  onChange={handleOptionChange}
                />
                Set as active
              </label>
            </div>
          </form>
        )}
        {title === 'Replicate to O2O' ? (
          o2OTimelines.length > 0 ? (
            <div style={{ padding: '1rem' }}>
              <label htmlFor="select-o2o-timeline">Select Timeline</label>
              <select
                id="select-o2o-timeline"
                role="combobox"
                placeholder="Select O2O Timeline"
                value={timeLine}
                onChange={(e) => {
                  setTimeLine(e.target.value)
                }}
              >
                {o2OTimelines.map((t) => {
                  return (
                    <option key={t.i} value={t.value}>
                      {t.text}
                    </option>
                  )
                })}
              </select>
            </div>
          ) : (
            <div>Loading O2O timeline</div>
          )
        ) : null}
        <div className="actions">
          <button type="button" className="button" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="button primary"
            onClick={handleConfirm}
          >
            Confirm and Save
          </button>
        </div>
      </div>
    </div>
  )
}

export const useConfirmationDialog = ({ title, message, page }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false)

  const Dialog = ({ onConfirm }) =>
    isDialogVisible &&
    ReactDOM.createPortal(
      <ConfirmationDialog
        page={page}
        title={title}
        message={message}
        onCancel={() => setIsDialogVisible(!isDialogVisible)}
        onConfirm={(value) => {
          onConfirm(value)
          setIsDialogVisible(!isDialogVisible)
        }}
      />,
      document.getElementById('portal')
    )

  return {
    Dialog,
    showDialog: () => setIsDialogVisible(true),
  }
}

export default React.memo(ConfirmationDialog)
